<template>
  <!-- The rank pill from the legacy header (Lv.N + the rank, the 실무 레벨 popover),
       mounted in the engine chrome (G2, ruled 2026-09-07: the points header
       mounts on engine routes). The rank is the loop's standing (ruled
       2026-09-12): points from learned / 노출 / 적용, each phrase once. The
       home sets it once it holds states and records; a pill that mounts
       first loads the same two reads itself. -->
  <div class="erp">
    <button class="erp__pill" type="button" :aria-expanded="open" aria-label="실무 레벨" @click.stop="open = !open">
      <b>Lv.{{ rank.lv }}</b><span class="erp__name">{{ rank.name }}</span>
    </button>
    <div v-if="open" class="erp__scrim" @click="open = false"></div>
    <!-- one design for the point system everywhere (ruled 2026-09-13):
         the popover renders the shared guide, the log's level layer too -->
    <div v-if="open" class="erp__ladder" role="dialog" aria-label="실무 레벨">
      <EngineLevelGuide />
    </div>
  </div>
</template>

<script>
import { rankForPoints } from '@/services/engineLoop';
import { standing, ensureStanding } from '@/services/engineStanding';
import { waitForAuth } from '@/utils/authWait';
import engineStateService from '@/api/engineStateService';
import engineDeployService from '@/api/engineDeployService';
import EngineLevelGuide from '@/components/engine/EngineLevelGuide.vue';

export default {
  name: 'EngineRankPill',
  components: { EngineLevelGuide },
  data() { return { open: false, st: standing }; },
  computed: {
    // the level is the loop's standing (ruled 2026-09-12): learned × 1 +
    // 노출 × 2 + 적용 × 3, each phrase once — never the legacy 복습 count
    rank() { return rankForPoints(this.st.points); },
  },
  async mounted() {
    if (standing.known) return;
    try {
      const user = await waitForAuth();
      if (user && user.uid) await ensureStanding(user.uid, { stateService: engineStateService, deployService: engineDeployService });
    } catch (e) { /* Lv.1 until a surface derives it */ }
  },
};
</script>

<style scoped>
.erp { position: relative; display: inline-flex; }
.erp__pill {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 10px 4px 4px; border: 1px solid var(--hairline); border-radius: 999px;
  background: var(--surface); cursor: pointer; font: inherit;
}
.erp__pill > b { padding: 2px 8px; border-radius: 999px; background: var(--accent-strong); color: #fff; font-size: 11px; font-weight: 800; }
.erp__name { font-size: 12.5px; font-weight: 700; color: var(--text-primary); }
.erp__scrim { position: fixed; inset: 0; z-index: 70; }
.erp__ladder {
  position: absolute; top: 40px; right: 0; z-index: 71; width: 244px; max-height: min(70vh, 480px); overflow-y: auto;
  background: var(--surface); border: 1px solid var(--hairline); border-radius: 16px; padding: 14px 16px 16px;
  box-shadow: 0 18px 40px -18px rgba(25, 26, 30, 0.35);
}

</style>
